import { useCallback, useState } from "react";
import { errorMessage, syncPendingProducts } from "../services/blingService";

const MAX_BATCHES = 1000;

// Envia ao Bling os produtos novos/alterados, um por chamada, pra mostrar o
// progresso produto a produto (done/total e o último enviado).
export function useBlingProductSync() {
  const [syncing, setSyncing] = useState(false);
  const [done, setDone] = useState(0);
  const [remaining, setRemaining] = useState(null);
  const [current, setCurrent] = useState(null);
  const [errors, setErrors] = useState([]);

  const start = useCallback(async () => {
    setSyncing(true);
    setDone(0);
    setRemaining(null);
    setCurrent(null);
    setErrors([]);
    try {
      for (let batch = 0; batch < MAX_BATCHES; batch++) {
        const result = await syncPendingProducts(1);
        const handled =
          (result.results?.length || 0) + (result.errors?.length || 0);
        setDone((n) => n + handled);
        setErrors((prev) => [...prev, ...(result.errors || [])]);
        setRemaining(result.remaining);
        const last =
          result.results?.[result.results.length - 1] || result.errors?.[0];
        if (last) setCurrent(last.code);
        if (!result.remaining || !handled) break;
      }
    } catch (err) {
      setErrors((prev) => [...prev, { code: "—", error: errorMessage(err) }]);
    } finally {
      setSyncing(false);
    }
  }, []);

  return { syncing, done, remaining, current, errors, start };
}
